'use client';

import React, { useEffect, useState } from 'react';
import ProductResponsiveImage from './ProductResponsiveImage';
import { PRODUCT_MAIN_IMAGE_WIDTHS } from '@/utils/cdnResponsiveImage';

const MAIN_PRODUCT_SIZES = '(max-width: 640px) 100vw, 500px';

export default function MagnifyImage({
  src,
  alt,
  isLcp = false,
}: {
  src: string;
  alt: string;
  isLcp?: boolean;
}) {
  const [isZoomed, setIsZoomed] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isSmallScreen, setIsSmallScreen] = useState(true);

  useEffect(() => {
    const resizeListener = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    resizeListener();
    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setMousePosition({ x, y });
  };

  return (
    <div
      className="relative w-full aspect-square max-w-[600px] mx-auto overflow-hidden rounded-xl hover:cursor-zoom-in"
      onMouseEnter={() => setIsZoomed(true && !isSmallScreen)}
      onMouseLeave={() => setIsZoomed(false)}
      onMouseMove={handleMouseMove}
    >
      <ProductResponsiveImage
        src={src}
        alt={alt}
        widths={PRODUCT_MAIN_IMAGE_WIDTHS}
        fallbackWidth={640}
        sizes={MAIN_PRODUCT_SIZES}
        width={500}
        height={500}
        loading={isLcp ? 'eager' : 'lazy'}
        fetchPriority={isLcp ? 'high' : 'auto'}
        decoding={isLcp ? 'sync' : 'async'}
        className={`absolute inset-0 h-full w-full object-cover transition-transform duration-300 ${
          isZoomed ? 'scale-[2.5]' : 'scale-100'
        }`}
        style={{
          objectFit: 'cover',
          transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
        }}
      />
    </div>
  );
}
